// Auto-generated from Contentful - DO NOT EDIT
// Generated at: 2026-02-04T02:14:54.504Z

const videoTourReportCards = {
  pageName: `Report Cards & Employee Feedback`,
  tourTitle: `Report Cards & Employee Feedback`,
  videoUrl: `https://www.loom.com/embed/02978469aac848a191304f30ade5f84a`,
  description: `Feedback and coaching for your employees is critical in order to unlock their potential. Report Cards are key when considering performance reviews, pay increases, or when terminating an employee.`,
  buttonLabel: `Got it, Thanks!`,
  imageUrl: {
    assetId: `3P9NgTUPjMGrnr68AWifGr`,
    url: `/assets/contentful/3P9NgTUPjMGrnr68AWifGr.png`,
    title: `Report Card Feature Preview Image`,
    description: ``,
  },
} as const;

export default videoTourReportCards;
